module.exports = __webpack_public_path__ + "img/images_esg_2_1.23e6b50d.jpg";